import { v4 as uuidv4 } from 'uuid'

let traceId = uuidv4()
/**
 * Get a traceId for analytics and remote logging
 * Retrieval priority: from DCF via query params -> sessionStorage -> newly generated UUID
 *
 * @param {String} id - traceId passed via query params from DCF
 * @returns {String}
 */
export function getTraceId(id) {
  traceId = id || sessionStorage.getItem('traceId') || traceId
  sessionStorage.setItem('traceId', traceId)
  return traceId
}
